import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import * as uuid from 'uuid';
import {
  ChoiceButton,
  FormService,
  LangService,
  LoaderService,
  NavigateService,
  ShortcutAction
} from 'ngx-satoris';
import {ApiService} from '../../../shared/services/api.service';
import {SyncService} from '../../../shared/services/sync.service';
import {enumToArrayName, enumToArrayObjectSelect} from '../../../shared/utils/enumToArrayObject';
import {ActivatedRoute, Router} from '@angular/router';
import {
  Currency,
  OperationType,
  PassportType,
  RequestCashType, RequestMNTAType,
  RequestWithDuplicata
} from 'src/app/shared/models/request';
import {DocumentType, Gender} from 'src/app/shared/models/user';
import {RequestService} from 'src/app/shared/services/request.service';
import {endOfDay, format, isAfter, subYears} from 'date-fns';
import {isJsonParsable} from 'src/app/shared/utils/parseMetadata';
import {QueueService} from '../../../shared/services/queue.service';
import {CartService, FormApplication} from '../../../shared/services/cart.service';
import {ScanDocumentService} from 'src/app/shared/services/scan-document.service';
import {environment} from '../../../../environments/environment';
import {documentTypeIsPreEnroll, getDocumentTypeIsExit} from 'src/app/shared/models/document-type-helpers';
import {atLeastOneNonEmptyValidator, clearInputOnlySpaces} from 'src/app/shared/services/form-utils';
import {hasValue, warnIfInvalidName} from 'src/app/shared/utils/form';
import {VisaFN} from 'src/app/shared/models/forms';

@Component({
  selector: 'app-admin-request-create',
  templateUrl: './admin-request-create.component.html',
  styleUrls: ['./admin-request-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminRequestCreateComponent implements OnInit {
  form: FormGroup;
  documentType: any; // legacy; no longer used in template
  choiceButtons?: ChoiceButton[] = [
    {text: 'global.Yes', value: 'Yes', backgroundColor: 'var(--clr-lt)', textColor: 'var(--clr-dk)', opacity: '0.7', selected: {backgroundColor: '#6fb76b', textColor: 'var(--clr-lt)', opacity: '1'}},
    {text: 'global.No', value: 'No', backgroundColor: 'var(--clr-lt)', textColor: 'var(--clr-dk)', opacity: '0.7', selected: {backgroundColor: 'var(--clr-btn-red)', textColor: 'var(--clr-lt)', opacity: '1'}}
  ];
  isPreenroll = false;
  DocType = DocumentType;
  allNationalities = this.request.getNationalities(true);
  params: {
    fromRoute: 'dashboard' | 'admin-request',
    prefill?: {
      firstName: string,
      lastName: string,
      birthDay: string,
      passportType: PassportType,
      gender: string,
      nationality: string,
      passportNr: string,
      existingValidEntryReferenceOfficer: string
    }
  };
  submitted = false;
  genderOptions: {name: string, value: string}[];
  birthDayValidator = {
    minDate: format(subYears(new Date(), 125), 'yyyy-MM-dd'),
    maxDate: format(endOfDay(new Date()), 'yyyy-MM-dd')
  };
  passportTypeOptions: {name: string, value: string}[];
  officerOptions: {name: string, value: string}[];
  private borderPassControls = [
    {formCtrlName: 'borderPassNumber', validators: [Validators.required, Validators.maxLength(36)]},
    {formCtrlName: 'residentialAddress', validators: [Validators.required, Validators.maxLength(100)]},
    {formCtrlName: 'issueDate', validators: [Validators.required]},
    {formCtrlName: 'expiryDate', validators: [Validators.required]},
    {formCtrlName: 'reason', validators: [Validators.required, Validators.maxLength(100)]},
    {formCtrlName: 'authorizedCrossingPoints', validators: [Validators.required, Validators.maxLength(100)]}
  ];
  isOnlyMrz = false;
  showCamera: boolean = false;
  showFaceCheck: boolean;
  borderPassPicture: string;
  private borderPassDateRangeValidator: ValidatorFn | null = null;

  constructor(private formBuilder: FormBuilder,
    public nav: NavigateService,
    public api: ApiService,
    public forms: FormService,
    public scanDocument: ScanDocumentService,
    private queue: QueueService,
    private loader: LoaderService,
    private sync: SyncService,
    private changeDetectorRef: ChangeDetectorRef,
    private lang: LangService,
    private router: Router,
    private cart: CartService,
    private request: RequestService,
    private route: ActivatedRoute) {
    this.borderPassPicture = '';
    this.passportTypeOptions = enumToArrayName(PassportType).map((item: any) => ({name: this.lang.transform('DYN.' + item), value: item}));
    this.route.queryParams.subscribe((params: any) => {
      this.params = {...params, prefill: isJsonParsable(params.prefill)};
    });
  }

  ngOnInit() {
    this.setForm();
    this.genderOptions = enumToArrayObjectSelect(Gender, '').filter((item: any) => item.name !== Gender.OTHER);
    this.documentType = this.transformSelect(this.api.userInfo?.server?.paymentRequests);
    this.officerOptions = [
      {name: this.lang.transform('officer.unknown'), value: 'UNKNOWN.OFFICER'},
      ...Object.values(this.sync.users || {}).map(user => ({
        name: user.accountName,
        value: user.accountName
      }))
    ];
    this.changeDetectorRef.detectChanges();
  }

  setForm() {
    this.isOnlyMrz = this.scanDocument.documentError === 'err.noCard' && !this.scanDocument.scanDatas.valid;
    this.form = this.formBuilder.group({
      FirstName: [{value: this.params.prefill?.firstName || '', disabled: !!this.params.prefill?.firstName && !this.isOnlyMrz}, [
        Validators.pattern('^[A-Za-z\\s\\-]+$'),
        Validators.maxLength(50)]],
      passportType: [{value: this.params.prefill?.passportType || PassportType.ORDINARY, disabled: !!this.params.prefill?.passportType && !this.isOnlyMrz}, [Validators.required]],
      LastName: [{value: this.params.prefill?.lastName || '', disabled: !!this.params.prefill?.lastName && !this.isOnlyMrz}, [
        Validators.pattern('^[A-Za-z\\s\\-]+$'),
        Validators.maxLength(50)]],
      BirthDay: [{value: (this.params.prefill?.birthDay !== undefined && this.params.prefill?.birthDay !== null && this.params.prefill?.birthDay !== '') ? format(new Date(this.params.prefill.birthDay), 'yyyy-MM-dd') : '', disabled: (this.params.prefill?.birthDay !== undefined && this.params.prefill?.birthDay !== null && this.params.prefill?.birthDay !== '') && !this.isOnlyMrz}, Validators.required],
      gender: [{value: this.params.prefill?.gender ? this.params.prefill.gender : '', disabled: !!this.params.prefill?.gender && !this.isOnlyMrz}, [Validators.required]],
      nationality: [{value: this.params.prefill?.nationality || '', disabled: !!this.params.prefill?.nationality && !this.isOnlyMrz}, [Validators.required]],
      passportNr: [{value: this.params.prefill?.passportNr || '', disabled: !!this.params.prefill?.passportNr && !this.isOnlyMrz}, [
        Validators.required,
        Validators.pattern('^[A-Za-z0-9\\s\\-]+$'),
        Validators.maxLength(20)
      ]],
      existingValidEntryReferenceOfficer: [{value: this.params.prefill?.existingValidEntryReferenceOfficer || '', disabled: !!this.params.prefill?.existingValidEntryReferenceOfficer}, [
        Validators.pattern('^[A-Za-z0-9\\s\\-\\.\\+\\@]+$'),
        Validators.maxLength(100)]]
    });
    this.form.setValidators(atLeastOneNonEmptyValidator(['FirstName', 'LastName']));
    this.form.updateValueAndValidity({onlySelf: false, emitEvent: false});
    if(this.params.prefill?.nationality && this.api.env.nationalityNoDeclaration.includes(this.params.prefill.nationality)) {
      this.form.addControl('borderPass', this.formBuilder.control('No', Validators.required));
    }
  }

  submitForm(cameraProblem: boolean) {
    clearInputOnlySpaces(this.form, undefined, true);
    const firstName = this.form?.get(VisaFN.FIRST_NAME)?.value?.trim();
    const lastName = this.form?.get(VisaFN.LAST_NAME)?.value?.trim();

    warnIfInvalidName(firstName, lastName, this.loader).then(canContinue => {
      if(!canContinue) {
        return;
      }

      this.submitted = true;
      if(this.forms.getFormErrors(this.form).length < 1) {
        const isBorderPass: boolean = this.form.get('borderPass')?.value === 'Yes' && this.api.env.nationalityNoDeclaration.includes(this.form.get('nationality').value);
        if(isBorderPass && !this.borderPassPicture && !cameraProblem){
          this.showCamera = true;
        } else {
          this.showCamera = false;
          this.showFaceCheck = false;
        }
        this.submitted = false;
        this.registerPayment();
      }
    });
  }

  registerPayment() {
    const serializedData = JSON.stringify({
      FirstName: this.form.get('FirstName')?.value?.trim().toUpperCase() || '',
      LastName: this.form.get('LastName')?.value?.trim().toUpperCase() || '',
      BirthDay: new Date(this.form.get('BirthDay')?.value).getTime() || '',
      Gender: this.form.get('gender')?.value || '',
      PassportType: this.form.get('passportType')?.value || '',
      Nationality: this.form.get('nationality')?.value || '',
      PassportNumber: this.form.get('passportNr')?.value?.trim().replace(/\s/g, '').toUpperCase() || '',
      BorderPass: this.form.get('borderPass')?.value || 'No',
      BorderPassNumber: this.form.get('borderPassNumber')?.value?.trim() || '',
      ResidentialAddress: this.form.get('residentialAddress')?.value?.trim() || '',
      IssueDate: hasValue(this.form.get('issueDate')?.value, 'date') ? new Date(this.form.get('issueDate')?.value).getTime() : undefined,
      ExpiryDate: hasValue(this.form.get('expiryDate')?.value, 'date') ? new Date(this.form.get('expiryDate')?.value).getTime() : undefined,
      Reason: this.form.get('reason')?.value?.trim() || '',
      AuthorizedCrossingPoints: this.form.get('authorizedCrossingPoints')?.value?.trim() || '',
      ExistingValidEntryReferenceOfficer: (this.form.get('existingValidEntryReferenceOfficer')?.value === 'UNKNOWN.OFFICER' ? '' : this.form.get('existingValidEntryReferenceOfficer')?.value) || '',
      BorderPassPicture: this.borderPassPicture || undefined
    });

    const batchId = this.cart.getUniqueReference([]);
    const register = () => {
      const nationality = this.form.get('nationality')?.value;
      const firstName = this.form.get('FirstName')?.value?.trim();
      const lastName = this.form.get('LastName')?.value?.trim();
      this.loader.loading(true);
      let paymentPromise;
      const isBorderPass: boolean = !!nationality && this.api.env.nationalityNoDeclaration.includes(nationality) && this.form.get('borderPass')?.value === 'Yes';
      if(isBorderPass) {
          const payment: { request_id: string, person_id: number, serialized: string}[] = [{
            request_id: getDocumentTypeIsExit(),
            person_id: undefined,
            serialized: JSON.stringify({
              FirstName: firstName.toUpperCase() || '',
              LastName: lastName.toUpperCase() || '',
              BirthDay: new Date(this.form.get('BirthDay')?.value).getTime() || '',
              Gender: this.form.get('gender')?.value || '',
              Nationality: this.form.get('nationality')?.value || '',
              PassportNumber: this.form.get('passportNr')?.value?.trim().replace(/\s/g, '').toUpperCase() || '',
              BorderPass: this.form.get('borderPass')?.value || 'No',
              PassportType: this.form.get('passportType')?.value || '',
              BorderPassNumber: this.form.get('borderPassNumber').value?.trim(),
              ResidentialAddress: this.form.get('residentialAddress').value?.trim(),
              IssueDate: hasValue(this.form.get('issueDate')?.value, 'date') ? new Date(this.form.get('issueDate')?.value).getTime() : undefined,
              ExpiryDate: hasValue(this.form.get('expiryDate')?.value, 'date') ? new Date(this.form.get('expiryDate')?.value).getTime() : undefined,
              Reason: this.form.get('reason').value?.trim(),
              AuthorizedCrossingPoints: this.form.get('authorizedCrossingPoints').value?.trim(),
              ExistingValidEntryReferenceOfficer: this.form.get('existingValidEntryReferenceOfficer')?.value === 'UNKNOWN.OFFICER' ? '' : this.form.get('existingValidEntryReferenceOfficer')?.value,
              BorderPassPicture: this.borderPassPicture|| undefined
            })
          }];
          paymentPromise = this.queue.addToQueue('registerMNTAPayment', [payment, batchId, undefined, false, RequestMNTAType.IVERI, undefined, environment.appVersion.join('.'), new Date().getTime()], 5000, undefined, undefined, true);
      } else {
        const params: any[] = [
          undefined,
          getDocumentTypeIsExit(),
          '',
          RequestCashType.CASH,
          this.api.userPlaceId,
          undefined,
          undefined,
          undefined,
          undefined,
          serializedData,
          batchId,
          undefined,
          environment.appVersion.join('.'),
          new Date().getTime()
        ];
        paymentPromise = this.queue.addToQueue('registerCashPayment', params, 5000, undefined, undefined, true);
      }

      return paymentPromise.then((res: any) => {
        this.loader.loading(false);
            const paymentId = res.id ? res.id : res.ids[0];
            const metadata = {
              BirthDay: this.form.get('BirthDay').value,
              FirstName: firstName,
              LastName: lastName,
              Gender: this.form.get('gender').value,
              Nationality: this.form.get('nationality').value,
              PassportNumber: this.form.get('passportNr').value?.trim().replace(/\s/g, '').toUpperCase() || '',
              PassportType: this.form.get('passportType').value,
              BorderPass: this.form.get('borderPass')?.value,
              BorderPassNumber: this.form.get('borderPassNumber')?.value?.trim() || undefined,
              ResidentialAddress: this.form.get('residentialAddress')?.value?.trim() || undefined,
              IssueDate: this.form.get('issueDate')?.value || undefined,
              ExpiryDate: this.form.get('expiryDate')?.value || undefined,
              Reason: this.form.get('reason')?.value?.trim() || undefined,
              AuthorizedCrossingPoints: this.form.get('authorizedCrossingPoints')?.value?.trim() || undefined,
              ExistingValidEntryReferenceOfficer: this.form.get('existingValidEntryReferenceOfficer')?.value === 'UNKNOWN.OFFICER' ? '' : this.form.get('existingValidEntryReferenceOfficer')?.value?.trim() || undefined,
              BorderPassPicture: this.borderPassPicture || undefined
            };

            if(((this.api.env.nationalityNoDeclaration.includes(metadata.Nationality) && this.form.get('borderPass').value === 'Yes')) || this.params.prefill) {
              if(res.queueId) {
                const offlineData: FormApplication = {travelName: '', plannedEntry: null, currentPerson: null, requests: [], visaFeesAndTerms: false};
                offlineData.queueId = res.queueId;
                offlineData.offlineParentMethodName = isBorderPass ? 'registerMNTAPayment' : 'registerCashPayment';
                offlineData.requests.push({
                  visaType: {
                    id: getDocumentTypeIsExit(),
                    amountCents: 0,
                    currency: Currency.USD
                  },
                  metadata: metadata
                } as RequestWithDuplicata);

                this.nav.to('admin-request-select/null', undefined, {queryParams: {from: this.params.fromRoute, offlineApplication: JSON.stringify(offlineData)}});
                return;
              } else {
                this.nav.to('admin-request-select/' + paymentId, undefined, {queryParams: {from: this.params.fromRoute}});
              }
            } else {
              this.nav.to('admin-request-face-check/', res.queueId ? null : undefined, {queryParams: {
                paymentId: res.queueId ? null : paymentId,
                userPlaceID: this.api.userPlaceId,
                placeID: res.created_place_id,
                paymentIsNotDocument: 'No',
                createdAt: res.createdAt ? res.createdAt : new Date(Date.now()),
                fromScanPassport: true,
                from: this.params.fromRoute,
                operation: OperationType.OUT,
                offlineApplication: res.queueId ? JSON.stringify({queueId: res.queueId, batchId: batchId, isDeparture: true, offlineParentMethodName: isBorderPass ? 'registerMNTAPayment' : 'registerCashPayment', metadata: metadata}) : undefined}});
            }
        }).catch((err) => {
          this.submitted = false;
          this.loader.loading(true, {type: 'error', message: err});
        });
    };
    return this.loader.loading(true, {type: 'question', message: this.lang.transform('exit.ask'), btnLabel: 'global.confirm'}).then((done: boolean) => {
      if(done) {
        return register();
      }
    });
  }


  transformSelect(arrayObj: any) {
    const arrayNew : any[]= [];
    arrayObj?.forEach((obj: any) => {
      const {type, id}: any = obj;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      arrayNew.push({name: type + ' : ' + obj.amountCents / 100 +' '+ obj.currency, value: JSON.stringify({type, id})});
    });
    return arrayNew;
  }

  goToPreviousUrl() {
    this.router.navigateByUrl(localStorage.getItem('previous_url'));
  }

  changeSelect(event: any) {
    const parsedValue = isJsonParsable(event?.target?.value);
    const {id} = parsedValue || {};
    if(!this.form) return;
    const hasBuyingOption = this.form.contains && this.form.contains('buyingOption');
    if(documentTypeIsPreEnroll(id) && hasBuyingOption) {
      this.isPreenroll = true;
      const currentValues = this.form.value;
      this.setForm();
      this.form.patchValue(currentValues);
      this.form.controls['buyingOption'].setValue(event.target.value);
    } else if(this.isPreenroll && hasBuyingOption) {
      this.isPreenroll = false;
      const currentValues = this.form.value;
      this.setForm();
      this.form.patchValue(currentValues);
      this.form.controls['buyingOption'].setValue(event.target.value);
    }
  }


  checkIfBorderPass() {
    const nationality = this.form.get('nationality')?.value;
    if(nationality && this.api.env.nationalityNoDeclaration.includes(nationality)) {
      this.toggleBorderPass(true);
    } else {
      this.toggleBorderPass(false);
    }
  }

  private toggleBorderPass(e: boolean) {
    if(e) {
      this.form.addControl('borderPass', this.formBuilder.control('', Validators.required));
    } else {
      if(this.form.contains('borderPass')) {
        this.form.removeControl('borderPass');
      }
      this.borderPassControls.forEach(control => {
        if(this.form.contains(control.formCtrlName)) {
          this.form.removeControl(control.formCtrlName);
        }
      });
    }
  }

  borderPassCheck(event: any) {
    const dateRangeValidator = (): ValidatorFn => (form: FormGroup): ValidationErrors | null => {
      const birthDateControl = form.get('BirthDay');
      const issueDateControl = form.get('issueDate');
      const expiryDateControl = form.get('expiryDate');
      if(!birthDateControl || !issueDateControl || !expiryDateControl) {
        return null;
      }
      const birthDate = birthDateControl.value;
      const issueDate = issueDateControl.value;
      const expiryDate = expiryDateControl.value;
      let hasError = false;
      if(birthDate && issueDate && isAfter(new Date(birthDate), new Date(issueDate))) {
        birthDateControl.setErrors({...birthDateControl.errors, 'afterIssueDate': true});
        hasError = true;
      } else {
        const errors = {...birthDateControl.errors};
        delete errors.afterIssueDate;
        birthDateControl.setErrors(Object.keys(errors).length ? errors : null);
      }
      if(birthDate && expiryDate && isAfter(new Date(birthDate), new Date(expiryDate))) {
        birthDateControl.setErrors({...birthDateControl.errors, 'afterExpiryDate': true});
        hasError = true;
      } else {
        const errors = {...birthDateControl.errors};
        delete errors.afterExpiryDate;
        birthDateControl.setErrors(Object.keys(errors).length ? errors : null);
      }
      if(issueDate && expiryDate && isAfter(new Date(issueDate), new Date(expiryDate))) {
        issueDateControl.setErrors({...issueDateControl.errors, 'afterExpiryDate': true});
        hasError = true;
      } else {
        const errors = {...issueDateControl.errors};
        delete errors.afterExpiryDate;
        issueDateControl.setErrors(Object.keys(errors).length ? errors : null);
      }
      return hasError ? {dateRangeError: true} : null;
    };

    if(event === 'Yes') {
      this.borderPassControls.forEach(control => {
        if(!this.form.contains(control.formCtrlName)) {
          this.form.addControl(control.formCtrlName, this.formBuilder.control('', control.validators));
        }
      });
      if(!this.borderPassDateRangeValidator) {
        this.borderPassDateRangeValidator = dateRangeValidator();
        this.form.addValidators(this.borderPassDateRangeValidator);
      }
      this.form.get('borderPassNumber').setValue(uuid.v1());
      this.form.updateValueAndValidity();
    } else {
      this.borderPassControls.forEach(control => {
        if(this.form.contains(control.formCtrlName)) {
          this.form.removeControl(control.formCtrlName);
        }
      });
      if(this.borderPassDateRangeValidator) {
        this.form.removeValidators(this.borderPassDateRangeValidator);
        this.borderPassDateRangeValidator = null;
      }
      this.form.updateValueAndValidity();
    }
  }

  changeToHKG() {
    return this.loader.loading(true, {type: 'question', message: 'passportType.changeToHKG', btnLabel: 'global.yes'}).then((done: boolean) => {
      if(done) {
        this.scanDocument.changeToHKG();
        this.form.controls.nationality.patchValue('HKG');
        this.params.prefill.nationality = 'HKG';
      }
    });
  }

  setBorderPassPicture(imageUrl: string) {
    this.borderPassPicture = imageUrl;
    this.showCamera = false;
    this.showFaceCheck = true;
  }


  close() {
    this.borderPassPicture = '';
    this.showFaceCheck = false;
    this.showCamera = true;
  }

  goBack() {
    this.borderPassPicture ='';
    this.showFaceCheck = false;
    this.showCamera = false;
  }

  protected readonly ShortcutAction = ShortcutAction;
}

